import log from "loglevel";

export enum SessionStorageItems {
    CART = "warenkorb",
    CUSTOMER = "customer",
    STEPCOUNTER = "stepCounter"
}

export default interface SessionStorageProviderProps {
    logger?: log.RootLogger;
}